import { Slider, SliderProps } from './slider';
import withEvents from 'analytics/withEvents';


const withEventsSliderComponent = withEvents<SliderProps>((sendEvent) => ({
  eventViewPhotoScroll({ dir, image, index, total }) {
    sendEvent('property_view_photo_scroll', 'property', {
      event: {
        'direction_scrolled': dir,
        'image': {
          'description': image.description,
          'image_url': image.url,
          'isFloorPlanPhoto': Boolean(image.isFloorPlan),
        },
        'image_index': index,
        'image_source': 'gallery',
        'index_total': total,
      },
    });
  },
}))(Slider);

export default withEventsSliderComponent;
